import { BaseControlBehaviour } from './BaseControlBehaviour';
/**
 */
export class ToggleBehaviour extends BaseControlBehaviour {
    constructor() {
        super('toggle');
    }

    protected installBehaviour(element: any): void {
        const selector = this.getBehaviorValue(element);

        $(element).on('change', () => {
            $(selector).toggle();
        });
    }
}

if(!window.Behaviours) window.Behaviours = {};
window.Behaviours.ToggleBehaviour = ToggleBehaviour;